const utils = {
  deepCopy: val => (val ? JSON.parse(JSON.stringify(val)) : val),
  sortIgnoringCase: arr => arr.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())),
  checkProp: (data, key) => Object.prototype.hasOwnProperty.call(data, key),
};

const AnchorUtils = {
  install(Vue) {
    if (!Object.prototype.hasOwnProperty.call(Vue, '$utils')) {
      Object.defineProperty(Vue.prototype, '$utils', {
        get: function get() { return utils; },
      });
    }
  },
};

export default AnchorUtils;
